import axios from 'axios';
import { apiUrl } from '../utility/Connections';

/**
 * Clase para manejar las llamadas API relacionadas con el ordenamiento
 */
class OrderingAPI {
    
    /**
     * Obtiene los headers de autorización
     */
    static getAuthHeaders() {
        const token = localStorage.getItem('access_token');
        return {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
        };
    }

    /**
     * DESCRIPTORS - Obtiene descriptores ordenados
     */
    static async getDescriptorOrdered(dscId) {
        try {
            const response = await axios.get(
                `${apiUrl}/descriptors/descriptor/${dscId}/ordered/`,
                this.getAuthHeaders()
            );
            return response.data;
        } catch (error) {
            console.error('Error al obtener descriptor ordenado:', error);
            throw error;
        }
    }

    /**
     * DESCRIPTORS - Actualiza el orden de los descriptores
     */
    static async updateDescriptorOrder(dscId, order) {
        try {
            const response = await axios.put(
                `${apiUrl}/descriptors/descriptor/${dscId}/order/`,
                { order },
                this.getAuthHeaders()
            );
            return response.data;
        } catch (error) {
            console.error('Error al actualizar orden de descriptores:', error);
            throw error;
        }
    }

    /**
     * LEADER BEHAVIORS - Obtiene comportamientos de liderazgo ordenados
     */
    static async getLeaderBehaviorsOrdered(latId) {
        try {
            const response = await axios.get(
                `${apiUrl}/leader-attributes-behaviors/behaviors/${latId}/ordered/`,
                this.getAuthHeaders()
            );
            return response.data;
        } catch (error) {
            console.error('Error al obtener comportamientos de liderazgo ordenados:', error);
            throw error;
        }
    }

    /**
     * LEADER BEHAVIORS - Actualiza el orden de comportamientos de liderazgo
     */
    static async updateLeaderBehaviorsOrder(behaviors) {
        try {
            const response = await axios.put(
                `${apiUrl}/leader-attributes-behaviors/behaviors/order/`,
                { behaviors },
                this.getAuthHeaders()
            );
            return response.data;
        } catch (error) {
            console.error('Error al actualizar orden de comportamientos de liderazgo:', error);
            throw error;
        }
    }

    /**
     * CULTURE BEHAVIORS - Obtiene comportamientos culturales ordenados
     */
    static async getCultureBehaviorsOrdered(catId) {
        try {
            const response = await axios.get(
                `${apiUrl}/culture-attributes-behaviors/behaviors/${catId}/ordered/`,
                this.getAuthHeaders()
            );
            return response.data;
        } catch (error) {
            console.error('Error al obtener comportamientos culturales ordenados:', error);
            throw error;
        }
    }

    /**
     * CULTURE BEHAVIORS - Actualiza el orden de comportamientos culturales
     */
    static async updateCultureBehaviorsOrder(behaviors) {
        try {
            const response = await axios.put(
                `${apiUrl}/culture-attributes-behaviors/behaviors/order/`,
                { behaviors },
                this.getAuthHeaders()
            );
            return response.data;
        } catch (error) {
            console.error('Error al actualizar orden de comportamientos culturales:', error);
            throw error;
        }
    }

    /**
     * SELFCARE BEHAVIORS - Obtiene comportamientos de autocuidado ordenados
     */
    static async getSelfcareBehaviorsOrdered(scaId) {
        try {
            const response = await axios.get(
                `${apiUrl}/selfcare-attributes-behaviors/behaviors/${scaId}/ordered/`,
                this.getAuthHeaders()
            );
            return response.data;
        } catch (error) {
            console.error('Error al obtener comportamientos de autocuidado ordenados:', error);
            throw error;
        }
    }

    /**
     * SELFCARE BEHAVIORS - Actualiza el orden de comportamientos de autocuidado
     */
    static async updateSelfcareBehaviorsOrder(behaviors) {
        try {
            const response = await axios.put(
                `${apiUrl}/selfcare-attributes-behaviors/behaviors/order/`,
                { behaviors },
                this.getAuthHeaders()
            );
            return response.data;
        } catch (error) {
            console.error('Error al actualizar orden de comportamientos de autocuidado:', error);
            throw error;
        }
    }

    /**
     * LEADER BEHAVIORS - Elimina un comportamiento de liderazgo
     */
    static async deleteLeaderBehavior(labId) {
        try {
            const response = await axios.delete(
                `${apiUrl}/leader-attributes-behaviors/behavior/${labId}/delete/`,
                this.getAuthHeaders()
            );
            return response.data;
        } catch (error) {
            console.error('Error al eliminar comportamiento de liderazgo:', error);
            throw error;
        }
    }

    /**
     * CULTURE BEHAVIORS - Elimina un comportamiento cultural
     */
    static async deleteCultureBehavior(cabId) {
        try {
            const response = await axios.delete(
                `${apiUrl}/culture-attributes-behaviors/behavior/${cabId}/delete/`,
                this.getAuthHeaders()
            );
            return response.data;
        } catch (error) {
            console.error('Error al eliminar comportamiento cultural:', error);
            throw error;
        }
    }

    /**
     * SELFCARE BEHAVIORS - Elimina un comportamiento de autocuidado
     */
    static async deleteSelfcareBehavior(sbeId) {
        try {
            const response = await axios.delete(
                `${apiUrl}/selfcare-attributes-behaviors/behavior/${sbeId}/delete/`,
                this.getAuthHeaders()
            );
            return response.data;
        } catch (error) {
            console.error('Error al eliminar comportamiento de autocuidado:', error);
            throw error;
        }
    }
}

export default OrderingAPI;